module.exports = __webpack_public_path__ + "static/slide1-af0df35163d5a0bff247cde09f6c9077.jpg";